











































import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import DatasourceServices, { ColumnConfig } from '@/services/datasource';
@Component
export default class AddDsTable extends Vue {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  @Prop() sourceId!: any;
  dsSrv = new DatasourceServices();
  data: any[] = [];
  formData: ColumnConfig = {};
  loading: boolean = false;

  @Watch('visible')
  async onVisibleChange() {
    this.formData = {};
    this.getTables();
  }

  async getTables() {
    this.loading = true;
    this.data = await this.dsSrv.tables({ sourceId_eq: this.sourceId });
    this.loading = false;
  }


  async submit() {
    const must: { field: 'tableNameEn'; message: string }[] = [{ field: 'tableNameEn', message: '表物理名不能为空' }];
    for (let val of must) {
      if (!this.formData[val.field]) {
        this.$message.error(val.message);
        return false;
      }
    }

    if (this.data.length > 0) {
      for (let val of this.data) {
          if (this.formData['tableNameEn'] == val['tableNameEn']) {
            this.$message.error('表物理名[' + this.formData['tableNameEn'] + ']已经存在');
            return false;
          }
        }
    }

    this.loading = true;
    let res = await this.dsSrv.saveTables([{sourceId: this.sourceId, ...this.formData}]);
    this.formData = {};
    this.$emit('success', res);
    this.syncVisible = false;
    this.loading = false;
  }

  close() {
    this.syncVisible = false;
    this.formData = {};
    this.$emit('success');
  }
}
